import { render, staticRenderFns } from "./pzhc.vue?vue&type=template&id=bbe597ec&scoped=true"
import script from "./pzhc.vue?vue&type=script&lang=js"
export * from "./pzhc.vue?vue&type=script&lang=js"
import style0 from "./pzhc.vue?vue&type=style&index=0&id=bbe597ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe597ec",
  null
  
)

export default component.exports